export const TRANSLATIONS_AUTH = {
  loginCard: {
    title: 'log_in.title',
    accessWithCredentials: 'global.your_email.placeholder',
    or: 'global.or.main',
    emailError: 'global.error_hint.email_format',
    continue: 'global.button.continue'
  },
  enterPassword: {
    title: 'global.enter_password.main',
    description: 'log_in.enter_password.description',
    placeholder: 'global.enter_password.main',
    invalidCredentials: 'global.error_hint.invalid_credentials',
    forgotPassword: 'global.forgot_password.main',
    button: 'global.button.continue'
  },
  goBack: 'global.button.back',
  verificationCode: {
    title: 'log_in.verification_code_sent.title',
    description: 'log_in.verification_code_sent.description',
    codeInput: {
      placeholder: 'global.verification_code.placeholder',
      errorFormat: 'global.error_hint.verification_code_format'
    },
    buttons: {
      disabled: 'global.button.resend_code.disabled',
      enabled: 'global.button.resend_code.enabled',
      continue: 'global.button.continue',
      helpcenter: 'global.verification_code_sent.access_helpcenter'
    }
  },
  createPass: {
    title: 'log_in.create_password.title',
    placeholder: 'global.create_password.placeholder',
    passwordValidations: {
      description: 'log_in.create_password.rules.title',
      firstCondition: 'log_in.create_password.rules.characters',
      secondCondition: 'log_in.create_password.rules.upper_case',
      thirdCondition: 'log_in.create_password.rules.number'
    },
    updateButton: 'global.button.update_password',
    continueButton: 'global.button.continue'
  },
  passwordRecoveryError: {
    title: 'log_in.password_recovery.error.title',
    description: 'log_in.password_recovery.error.description',
    primaryButton: 'global.button.recover_account',
    secondaryButton: 'global.button.resend_email.enabled'
  },
  forgotPassword: {
    samePass: 'log_in.password_recovery.error.previous_passwords'
  }
};
